// extracted by mini-css-extract-plugin
export default {"privacyContainer":"aaRZ2fIcavbNmpxQWJSY","mainText":"eRR5KiO2r987gg2RbFlM","subText":"CMUenDBM6B79xzaCFIzB","saveContainer":"iFcocvvVDI8HULbhIZ_P"};